document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.beliebte-swipe').forEach(function(sec){
    var grid=sec.querySelector('.featured-collection__items');
    var head=sec.querySelector('.section__header-wrap');
    if(!grid||!head||sec.querySelector('.bs-arrows'))return;
    var wrap=document.createElement('div');wrap.className='bs-arrows';
    ['prev','next'].forEach(function(dir){
      var b=document.createElement('button');b.type='button';
      b.className='bs-arrow bs-arrow--'+dir;
      b.setAttribute('aria-label',dir==='prev'?'Vorherige':'Weitere');
      b.innerHTML=dir==='prev'?'&#8249;':'&#8250;';
      b.addEventListener('click',function(){
        grid.scrollBy({left:(dir==='prev'?-1:1)*grid.clientWidth*0.9,behavior:'smooth'});
      });
      wrap.appendChild(b);
    });
    head.appendChild(wrap);
  });
});
